/**
 * Rendered review text, and the **only** `dangerouslySetInnerHTML` in the app.
 *
 * The HTML comes from `api/app/modules/reviews_social/markdown.py`, which
 * escapes every character of the author's input before a single rule runs and
 * then emits tags it wrote itself. There is no path by which what somebody
 * typed becomes markup, and `test_social_markdown.py` asserts that from the
 * other side with a property test.
 *
 * Deliberately one component, so this is one place to look. A page that
 * reached for `dangerouslySetInnerHTML` on its own would be the bug; there is
 * a vitest here that renders a `<script>` review and asserts no script element
 * exists, so a second copy would have to defeat that too.
 *
 * The client parses no Markdown at all — that is why there is no renderer in
 * this bundle and no dependency to keep patched.
 */
export default function Markdown({ html, className = '' }) {
  if (!html) return null
  return (
    <div
      className={`prose ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
